export const attendeeConstants = {

    GET_ATTENDEE_LIST_REQUEST: 'GET_ATTENDEE_LIST_REQUEST',
    GET_ATTENDEE_LIST_SUCCESS: 'GET_ATTENDEE_LIST_SUCCESS',
    GET_ATTENDEE_LIST_FAILURE: 'GET_ATTENDEE_LIST_FAILURE',

    SET_ACTIVE_PERSON_NO:'SET_ACTIVE_PERSON_NO',
    CREATE_ORDER:'CREATE_ORDER',
    UPDATE_ORDER:'UPDATE_ORDER',
    SET_PAYMETHOD:'SET_PAYMETHOD',
    REMOVE_ORDER: 'REMOVE_ORDER',
    UPDATE_DISCOUNT: 'UPDATE_DISCOUNT',
    SET_LEADER: 'SET_LEADER',
    REMOVE_ORDER_BY_CONDITION: 'REMOVE_ORDER_BY_CONDITION'
}